import { Activity } from "@/lib/api/customer";
import { CallContextLine } from "./CallContextLine";

/** Customer, who called whom, and call time, shown under a todo modal's title. The call parts exist only for automation todos. */
export function TodoContextLine({ todo }: { todo: Activity | null }) {
  return (
    <CallContextLine
      customerName={todo?.Customer?.long_name}
      callStartedAt={todo?.Call?.call_started_at}
      from={todo?.Call?.from}
      to={todo?.Call?.to}
    />
  );
}
